const iconName = 'phone2';
const width = 16;
const height = 16;

const svgPathData =
	'M4.99978 8.04984C5.63229 9.34295 6.68048 10.3864 7.97645 11.013C8.16937 11.1044 8.3962 11.0872 8.57316 10.9678L10.4814 9.69538C10.6529 9.58105 10.8705 9.56106 11.0599 9.64224L14.6298 11.1722C14.879 11.278 15.0281 11.5359 14.9956 11.8046C14.7621 13.6313 13.2076 15 11.366 15C5.64102 15 1 10.359 1 4.63398C1 2.79244 2.36871 1.23787 4.1954 1.00443C4.46412 0.971908 4.72195 1.12102 4.82778 1.37015L6.35909 4.94322C6.43954 5.13093 6.42068 5.34645 6.30884 5.51733L5.0408 7.45484C4.9234 7.63214 4.90782 7.8581 4.99978 8.04984Z';
const attributes = [
	['stroke', 'currentColor'],
	['stroke-width', '1.5'],
	['fill-rule', 'evenodd'],
	['clip-rule', 'evenodd'],
	['fill', 'none'],
];
export default {
	iconName: iconName,
	icon: [width, height, svgPathData, attributes],
};
